import React from "react";

const BlogContainer = (props) => {
    let displayContent = props.blogItem.description;
    const anchorId = props.anchorId;

    return (
        <>
            <div className="blog " id={anchorId}>
                <div className="bg-white">
                    <h3 className="text-title-21 lightBlue mb-3 mb-md-4 ">
                        {props.blogItem.title}
                    </h3>
                    <div
                        dangerouslySetInnerHTML={{ __html: displayContent }}
                        style={{ fontFamily: "inter" }}
                    />
                </div>
            </div>
        </>
    );
};

export default BlogContainer;
